import {createState} from './create';

export const initialState = createState();
